module.exports = __webpack_public_path__ + "static/img/pic_state_green@2x.1bc3aba.png";


//////////////////
// WEBPACK FOOTER
// ./static/icons/pic_state_green@2x.png
// module id = xKWG
// module chunks = 83